import { jsx as _jsx } from "react/jsx-runtime";
import '@/styles/Common/CharactersList.less';
const CharactersList = ({ characters, onCharacterSelect, charactersSelected, disableSelected = true, }) => {
    return (_jsx("ul", { className: "component-characters-list", children: characters.map((character) => {
            const disabled = disableSelected && (charactersSelected === null || charactersSelected === void 0 ? void 0 : charactersSelected.some((id) => id === character.id));
            const selected = charactersSelected === null || charactersSelected === void 0 ? void 0 : charactersSelected.some((id) => id === character.id);
            return (_jsx("li", { onClick: onCharacterSelect ? () => onCharacterSelect(character) : undefined, className: `component-characters-list-item ${disabled ? 'disabled' : ''} ${selected ? 'selected' : ''}`, children: character.name }, character.id));
        }) }));
};
export default CharactersList;
